import { BaseEntity } from '../../../../shared/models/ApiModels'

export type AuthAction = 'LOGIN' | 'LOGOUT' | string

export interface IAuthActivityLogModel extends BaseEntity { 
  userId: string | null
  username: string
  action: AuthAction
  success: boolean
  message: string
  loggedAt: string
}

export type SuccessFilter = 'all' | 'success' | 'failure'

export interface IAuthActivityLogFilter {
  username: string
  action: '' | 'LOGIN' | 'LOGOUT'
  success: SuccessFilter
  startDate: string
  endDate: string
}

export const initialAuthActivityLogFilter: IAuthActivityLogFilter = {
  username: '',
  action: '',
  success: 'all',
  startDate: '',
  endDate: '',
}

export const ACTION_OPTIONS: { value: '' | 'LOGIN' | 'LOGOUT'; label: string }[] = [
  { value: '', label: 'Tüm İşlemler' },
  { value: 'LOGIN', label: 'Giriş (LOGIN)' },
  { value: 'LOGOUT', label: 'Çıkış (LOGOUT)' },
]

export const SUCCESS_OPTIONS: { value: SuccessFilter; label: string }[] = [
  { value: 'all', label: 'Tüm Sonuçlar' },
  { value: 'success', label: 'Başarılı' },
  { value: 'failure', label: 'Başarısız' },
]
